import PageHandler from "./PageHandler";
import Pages from "Pages";

class LogsPageHandler extends PageHandler {
  constructor() {
    super("logs", Pages.LogsPage);
  }
}

export default LogsPageHandler;


// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/LogsPageHandler.js